module.exports = __webpack_public_path__ + "img/Screen Shot 2019-05-27 at 3.30.49 PM.9091d716.png";